<style>
  .UnSubmit {
    background-color: #ff9595 !important;
  }

  .Selected {
    background-color: #86e7d1 !important;
  }

  .MySecondDiv {
    width: 100%;
    transition: all 1.5s ease;
  }

  .MyFirstDiv {
    width: 0%;
    transition: all 1.5s ease;


  }

  /*
  .MyMainDiv:hover > .MyFirstDiv{
    width: 20%;
  }

  .MyMainDiv:hover > .MySecondDiv{
    width: 80%;
    padding-left: 5px;
  }
  */
</style>

<div class="col-xl-12 mb-30" [hidden]="Show_Lab_Form">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">
        <div class="d-block d-md-flex justify-content-between">
          <div class="d-block w-100">
            <h5 class="card-title border-0 pb-0">Calibration Technician Workbench</h5>
          </div>
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                  aria-controls="months" aria-selected="true">Laboratory Work Orders</a>
              </li>
              <li class="nav-item">
                <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                  aria-controls="months" aria-selected="true">On-site Work Orders</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 20px;">
                <div class="card card-statistics h-100" [hidden]="DataList_Kartable_Selected_DeviceBehfa.id>0">
                  <div class="card-body">

                    <div class="row">



                      <div class="col-md-3" (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_erja,1)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==1}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-danger rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-simplybuilt highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> Awaiting Work </p>
                                <h4>{{DataList_Kartable_wait_erja.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3"
                        (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_certificate,2)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==2}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-warning rounded-circle">
                                <span class="text-white">
                                  <i class="fa  fa-certificate highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> Awaiting Certificate Upload</p>
                                <h4>{{DataList_Kartable_wait_certificate.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3"
                        (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_certificate_check,3)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==3}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-info rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-check-circle highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> Awaiting Certificate Response</p>
                                <h4>{{DataList_Kartable_wait_certificate_check.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3" (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_upload,4)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==4}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-success rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-cloud-upload highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> Awaiting Check-out</p>
                                <h4>{{DataList_Kartable_wait_upload.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <br />
                    <br />

                    <div class="row">
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">Customer Name</label>
                        <input [(ngModel)]="Filter_Customer_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Customer_Order" type="text" class="form-control"
                          placeholder="Type here to search...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">Receipt Number</label>
                        <input [(ngModel)]="Filter_RecieveCode_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_RecieveCode_Order" type="text" class="form-control"
                          placeholder="Type here to search...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">Letter Number</label>
                        <input [(ngModel)]="Filter_Code2_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Code2_Order" type="text" class="form-control"
                          placeholder="Type here to search...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">Instrument English Name</label>
                        <input [(ngModel)]="Filter_Devicename_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Devicename_Order" type="text" class="form-control"
                          placeholder="Type here to search...">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-6">
                        <button *ngIf="!Procssing_Kartable" type="button" (click)="ReadData_Kartable()"
                          class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Refresh
                          Information
                        </button>
                        <button *ngIf="!Procssing_Kartable" type="button" (click)="set_Show_Lab_Form()"
                          class="btn btn-warning" style="margin-right: 5px;"><i class="fa  fa-cloud-upload"></i> Check Out from
                          Laboratory </button>
                        <button *ngIf="Procssing_Kartable" type="button" class="btn btn-info" style="margin-right: 5px;">
                          Please wait... <i class="fa fa-spin fa-spinner"></i> </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 mb-30" *ngFor="let item of DataList_Kartable
                      |filter:Filter_Customer_Order:'customer'
                      |filter:Filter_RecieveCode_Order:'recieveCode'
                      |filter:Filter_Code2_Order:'code2'
                      |filter:Filter_Devicename_Order:'devicename'
                      | paginate
                              : {
                                  id: 'DataList_Kartable',
                                  itemsPerPage: 20,
                                  currentPage: page_Kartable,
                                  totalItems: (DataList_Kartable
                                  |filter:Filter_Customer_Order:'customer'
                                  |filter:Filter_RecieveCode_Order:'recieveCode'
                                  |filter:Filter_Code2_Order:'code2'
                                  |filter:Filter_Devicename_Order:'devicename').length
                                }
                      ">

                        <div class="card h-100" [ngClass]="{'UnSubmit': item.controller.length>0}">
                          <div class="card-body">

                            <div class="row MyMainDiv" style="padding: 5px;">
                              <div class="MyFirstDiv">
                                <img src="{{BaseUrl}}{{item.username_img}}" title="{{item.username}}"
                                  style="width: 100%;height: 100%;" />
                              </div>
                              <div class="MySecondDiv">

                                <div style="float: left;">
                                  <p><span style="font-weight: 600;">Instrument</span> {{item.controller.length}}
                                    '{{item.devicename}}' </p>
                                </div>
                                <div style="float: right;">
                                  <p><span style="font-weight: 600;">Letter Number </span> '{{item.code2}}' </p>
                                </div>
                                <div style="clear: both;"></div>
                                <p style="cursor: pointer;text-decoration: underline;"
                                  (click)="openModal_Customer(templateCustomer,item)"><span
                                    style="font-weight: 600;">Customer Name </span> '{{item.customer}}
                                  ({{item.customer_code}})' </p>
                                <p><span style="font-weight: 600;">Certificate Address </span>
                                  '{{item.customer_address_certificate}}' </p>

                                <hr />
                                <div style="float: left;">
                                  <p><span style="font-weight: 600;">Instrument Code </span> '{{item.code}}' </p>
                                  <p><span style="font-weight: 600;">Instrument Serial Number</span> '{{item.serial}}' </p>
                                  <p><span style="font-weight: 600;">Receipt Number</span> '{{item.recieveCode}}' </p>
                                </div>
                                <div style="float: right;">
                                  <p><span style="font-weight: 600;">Calibration Technician</span> '{{item.expert_name}}' </p>
                                  <p><span style="font-weight: 600;">Status</span> '{{item.status}}' </p>
                                  <p><span style="font-weight: 600;">Delivery Date </span> '{{item.tarikhTahvi}}' </p>
                                </div>
                                <div style="clear: both;"></div>

                                <hr />

                                <span  *ngIf="item.flowchartRequestDsc">
                                  <p><span  style="font-weight: 600;">Restore Certificate</span>  '{{item.flowchartRequestDsc}}' </p>
                                  <hr/>
                                </span>                 

                                <p><span style="font-weight: 600;">Tariff Description</span> '{{item.tariff_dsc}}' </p>

                                <hr />

                                <div *ngIf="item.hasRequestToExit>0">
                                  <p *ngIf="item.hasRequestToExit==2" style="font-weight: 600;color: blue;">An instrument
                                    check-out request has been submitted.</p>
                                  <p *ngIf="item.hasRequestToExit==1" style="font-weight: 600;color: green;">
                                    The instrument check-out request has been approved.</p>

                                  <hr />
                                </div>

                                <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />

                                <div
                                  *ngIf="!item.Processing && item.status=='ارجاع' && !item.inlocation && item.typeItem==1">
                                  <!--
                                  <button type="button" (click)="OnSet_Calibration_DeviceBehfa(item,1)"
                                    class="btn btn-info">
                                    <i class="fa fa-building"></i> Select Behfa Equipment
                                  </button>
                                  -->

                                  <button (click)="openModalCalibrationDate(templateCalibrationDate,item)" type="button"
                                    class="btn btn-success" style="margin-left: 5px;">
                                    <i class="fa fa-check"></i> Perform Work at the Laboratory
                                  </button>

                                  <button (click)="openModal_LetterFile(templateLetterFile,item)" type="button"
                                    class="btn btn-warning" style="margin-left: 5px;">
                                    <i class="fa fa-file"></i> Additional Customer Information
                                  </button>

                                  <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                    (click)="openModal_Kartable(templateKartable,item)" style="margin-left: 5px;"
                                    type="button" class="btn btn-danger">
                                    <i class="fa fa-times-circle"></i> Return Instrument
                                  </button>

                                  <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                    (click)="openModal_RequestToExit(templateRequestToExit,item)"
                                    style="margin-left: 5px;" type="button" class="btn btn-warning">
                                    <i class="fa fa-cloud-upload"></i> Check Out Instrument
                                  </button>

                                </div>

                                <div *ngIf="!item.Processing && item.status=='انجام کار' && item.typeItem==2">



                                  <div class="row">
                                    <div class="form-group col-md-12">

                                      <button *ngIf="!item.src" type="button" class="btn btn-success"
                                        style="margin-right: 10px;" (click)="openModal_upload(templateUpload,item)"><i
                                          class="fa fa-upload"></i>
                                        Upload Calibration Certificate File </button>
                                      <a *ngIf="item.filename && !item.src" target="_blank" style="margin-right: 10px;"
                                        href="{{BaseUrl}}File/Calibration/{{item.filename}}" class="btn btn-info"><i
                                          class="fa fa-eye"></i> View Calibration Certificate File </a>

                                      <button *ngIf="item.src" [routerLink]="[item.src,{id:item.calibration_detail_id}]"
                                        style="margin-right: 10px;" type="button" class="btn btn-success"><i
                                          class="fa fa-file-code-o"></i> Register Data
                                      </button>

                                      <a style="margin-left: 10px;" *ngIf="item.certificate && item.src"
                                        style="margin-right: 10px;" target="_blank"
                                        href="{{BaseUrl}}{{item.certificate}}" class="btn btn-info"><i
                                          class="fa fa-eye"></i>
                                        View Calibration Certificate File </a>


                                      <button type="button" style="margin-right: 10px;"
                                        (click)="OnSet_Calibration_DeviceBehfa(item,0)" class="btn btn-info">
                                        <i class="fa fa-building"></i> Behfa Equipment
                                      </button>

                                      <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                        (click)="openModal_RequestToExit(templateRequestToExit,item)"
                                        style="margin-left: 5px;" type="button" class="btn btn-warning">
                                        <i class="fa fa-cloud-upload"></i> Check Out Instrument
                                      </button>

                                      <button type="button" *ngIf="item.filename || item.certificate"
                                        (click)="SubmitExpertCalibrationDate(item)" style="margin-top: 10px;"
                                        class="btn btn-warning"><i class="fa fa-check"></i> Submit Certificate for Review
                                      </button>

                                      <button type="button" *ngIf="item.controller.length>0"
                                        (click)="openModal_Controller(templateController,item)"
                                        style="margin-top: 10px;margin-left: 10px;" class="btn btn-danger"><i
                                          class="fa fa-file"></i> Reviewer Messages </button>

                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!item.Processing && item.status=='بررسی برای ثبت خروج'">
                                  <h6 style="color: red;"> Awaiting Check-out Registration Review </h6>
                                </div>

                                <div *ngIf="!item.Processing && item.status=='کنترل'">
                                  <h6 style="color: rgb(18 88 11);"> The certificate has been submitted for review. </h6>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>

                    <pagination-controls id="DataList_Kartable" nextLabel="Next" previousLabel="Previous"
                      (pageChange)="page_Kartable = $event"></pagination-controls>


                  </div>
                </div>

                <app-CalibrationDeviceBehfa *ngIf="DataList_Kartable_Selected_DeviceBehfa.id>0"
                  (OnBack_CalibrationDeviceBehfa_Action)="OnSet_Back_Calibration_DeviceBehfa($event)"
                  [inner_Kartable_Order_Interface]="DataList_Kartable_Selected_DeviceBehfa"
                  [inner_Can_Add_Edit]="CanModify_Kartable_Selected_DeviceBehfa"
                  [inner_Persian_Date]="PersianToDayDate">

                </app-CalibrationDeviceBehfa>

              </div>



            </div>

          </div>

          <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">

            <br />
            <br />

            <app-CalibrationInPositionList
              [hidden]="Selected_Calibration_Id_Form!=-1 || Selected_Calibration_Id_Fund.id!=0 || Selected_Calibration_Id_Evaluate.id!=0 || Selected_Calibration_Id_Certificate.id!=0"
              (OnBack_Calibration_Action_Form)="OnSet_Back_Calibration_Id_Form($event)"
              (OnBack_Calibration_Action_Form_Schedule)="OnSet_Back_Calibration_Id_Form_Schedule($event)"
              (OnBack_Calibration_Action_Fund)="OnSet_Back_Calibration_Id_Fund($event)"
              (OnBack_Calibration_Action_Certificate)="OnSet_Back_Calibration_Id_Certificate($event)"
              (OnBack_Calibration_Action_Evaluate)="OnSet_Back_Calibration_Id_Evaluate($event)">

            </app-CalibrationInPositionList>

            <app-CalibrationInPositionForm *ngIf="Selected_Calibration_Id_Form>-1"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Form($event)"
              [Calibration_Form_Id]="Selected_Calibration_Id_Form"
              [LetterRequestSchduleCustomer_Id]="Selected_Calibration_Id_Form_Schedule">

            </app-CalibrationInPositionForm>

            <app-FundsLetterList *ngIf="Selected_Calibration_Id_Fund.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Fund_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Fund">

            </app-FundsLetterList>

            <app-CalibrationEvaluateLetterForm *ngIf="Selected_Calibration_Id_Evaluate.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Evaluate_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Evaluate">

            </app-CalibrationEvaluateLetterForm>


            <app-CalibrationInPositionCertificate *ngIf="Selected_Calibration_Id_Certificate.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Certificate_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Certificate">

            </app-CalibrationInPositionCertificate>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<app-LabUploadDeviceForm *ngIf="Show_Lab_Form" [inner_UploadDevice_id]="1"
  (OnBack_UploadDevice_Action)="back_Show_Lab_Form($event)">

</app-LabUploadDeviceForm>

<ng-template #templateKartable>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Return Instrument by Code/Serial Number
      {{DataList_Kartable_Selected.code}}/{{DataList_Kartable_Selected.serial}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Kartable.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="OperationDsc_Kartable" name="OperationDsc_Kartable" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="RequestExit()"> Submit for Review <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Kartable.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRequestToExit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Instrument Check-out Request by Code/Serial Number
      {{DataList_Kartable_Selected_RequestToExit.code}}/{{DataList_Kartable_Selected_RequestToExit.serial}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_RequestToExit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="OperationDsc_RequestToExit" name="OperationDsc_RequestToExit" type="text"
          class="form-control" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="RequestToExit()"> Submit for Review <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_RequestToExit.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCalibrationDate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Perform Laboratory Work for Equipment '{{DataList_Kartable_Selected.devicename}}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CalibrationDate.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Additional Action Description </label>
        <input [(ngModel)]="CalibrationDate_Dsc" name="CalibrationDate_Dsc" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="OnSubmitCalibrationDate()"> Approve <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CalibrationDate.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateUpload>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Calibration Certificate File '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Select File </label>
          <input #file type="file" (change)="onFileSelected($event)" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Certificate Code </label>
          <input [(ngModel)]="certificate_user_code" name="certificate_user_code" type="text" class="form-control"
            placeholder="Type here...">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-upload"></i> Upload File </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_upload.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateController>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Reviewer Messages '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Controller.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>User</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Controller_Data_List">
              <td>{{Controller_Data_List.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Controller.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateLetterFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left">  Attached Files </h4>
    <br/>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterFile.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <h6 class="modal-title" style="float: right;">   Letter Number Customer '{{LetterFile_Data_Code}}' </h6>
      <h6 class="modal-title" style="float: left;">   Customer Letter Date '{{LetterFile_Data_Tarikh}}' </h6>
      <div style="clear: both;"></div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>File</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of LetterFile_Data_List">
              <td>{{LetterFile_Data_List.indexOf(item)+1}}</td>
              <td>
                <a target="_blank"  href="{{BaseUrl}}File/Letter/{{item}}"
                class="btn btn-success"><i class="fa fa-download"></i> View </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterFile.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCustomer>

  <div class="modal-body">
    <app-CutomerView [inner_customer_id]="Selected_DataList_Customer.customer_id">

    </app-CutomerView>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>
